import router from "../router";

const baseConfigurations = {
  articleColorHint: true,
  articleHint: true,
  pictureHint: true,
  pluralHint: true,
  praepositionHint: true,
  perfektHint: true,
  autoPlayWordSound: true,
  kasusObjektHint: true
  // pseudoTranslation: true,
};

const savedConfiguration = localStorage.getItem("sprkr/configurations")
  ? JSON.parse(localStorage.getItem("sprkr/configurations"))
  : {};

const configurations = { ...baseConfigurations, ...savedConfiguration };

const state = {
  zenMode: false,
  backRoute: null,
  lastRoute: null,
  configurations: configurations,
  title: "",
  sections: [
    {
      name: "Card Settings",
      configurations: [
        { model: "pictureHint", text: "Show picture" },
        { model: "articleHint", text: "Show articles" },
        { model: "articleColorHint", text: "Article colored" },
        { model: "pluralHint", text: "Show plural" },
        { model: "kasusObjektHint", text: "Show kasusobject" },
        { model: "perfektHint", text: "Show perfect" },
        { model: "autoPlayWordSound", text: "Auto play word sound" },
        {
          model: "praepositionHint",
          text: "Show prepositions",
          hint:
            "prepositions stand in front of a noun in order to describe its state (e.g. position in place/time); examples: to / at / after / behind"
        }
      ]
    }
    // {
    //   name: "Card Setting",
    //   configurations: [
    //     { model: "wordType", text: "Show word type" },
    //     { model: "reflexiv", text: "Show grammer" },
    //     { model: "plural", text: "Show plural" }
    //     { model: "pseudoTranslation", text: "Show pseudo translation" }
    //   ]
    // }
  ]
};

const actions = {
  navigateBack() {
    router.go(-1);
    // if (state.backRoute) {
    //   router.push(state.backRoute);
    // } else if (state.lastRoute.name) {
    //   router.go(-1);
    // } else {
    //   router.push({
    //     name: "Home"
    //   });
    // }
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations: {
    // SET_BACK_ROUTE - the page we set to go back to
    SET_BACK_ROUTE(state, backRoute) {
      state.backRoute = backRoute;
    },
    // SET_LAST_ROUTE - the browsers prev page for fallback
    SET_LAST_ROUTE(state, lastRoute) {
      state.lastRoute = lastRoute;
    },
    SET_PAGE_TITLE(state, title) {
      state.title = title;
    },
    TOGGLE_ZEN_MODE(state) {
      state.zenMode = !state.zenMode;
    },
    CLOSE_ZEN_MODE(state) {
      state.zenMode = false;
    },
    OPEN_ZEN_MODE(state) {
      state.zenMode = true;
    },
    TOGGLE_CONFIGURATION(state, key) {
      state.configurations[key] = !state.configurations[key];
      localStorage.setItem(
        "sprkr/configurations",
        JSON.stringify(state.configurations)
      );
    }
  }
};
